// extracted by mini-css-extract-plugin
export var completionBody = "_mj-2";
export var completionCard = "_mj-0";
export var completionFooter = "_mj-3";
export var completionTitle = "_mj-1";